import { times } from "lodash";
import { twJoin } from "tailwind-merge";

import { MarkdownRenderer } from "src/base-components/MarkdownRenderer/MarkdownRenderer";
import { SkeletonLine } from "src/manualReview/reviewCaseCommon/SkeletonLine";

export const FormSide: React.FC<{
  isLoading?: boolean;
  children: React.ReactNode;
  nodeName: string | undefined;
  description: string | undefined;
  noBorders?: boolean;
}> = ({
  isLoading,
  children,
  nodeName,
  description = "",
  noBorders = false,
}) => {
  return (
    <div
      className={twJoin(
        "flex min-w-[362px] max-w-150 basis-[33vw] flex-col",
        !noBorders && "border-gray-200 border-r border-l",
      )}
    >
      <div
        className="max-h-90 overflow-auto py-4 pl-6"
        data-loc="manual-review-task-description"
      >
        {!isLoading ? (
          <>
            <p className="font-inter-semibold-13px text-gray-800">{nodeName}</p>
            <MarkdownRenderer content={description} />
          </>
        ) : (
          <>
            <SkeletonLine className="h-4 w-[117px]" />
            <SkeletonLine className="mt-3 mb-7 h-4 w-[250px]" />
          </>
        )}
      </div>
      <div className="mx-3.5 border-gray-200 border-t" />
      <div className="min-h-0 flex-1 overflow-auto px-6">
        {!isLoading ? (
          children
        ) : (
          <div className="mt-8 space-y-[38px]">
            {times(3, (index) => (
              <div key={index}>
                <SkeletonLine className="h-3 w-[153px]" />
                <SkeletonLine className="mt-3 h-8 w-[490px]" />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
